export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11259.b6971e1a.jpg";